import script from "./SettingsActions.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsActions.vue?vue&type=script&setup=true&lang=js"

import "./SettingsActions.vue?vue&type=style&index=0&id=0d9f66ef&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9f66ef"]])

export default __exports__